module.exports = __webpack_public_path__ + "static/media/real_time_communication.866e6c0a.svg";